// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__NBWgI","dashboard__main":"Dashboard_dashboard__main__he3dr","dashboard__content":"Dashboard_dashboard__content__cv4H4"};